import {
  GetConfigPathsGradesResponse,
  UpdatePathsGradesConfig,
} from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsPathsGradesService = {
  async list(): Promise<GetConfigPathsGradesResponse> {
    const response = await httpClient.get<GetConfigPathsGradesResponse>(
      "v1/config/internal-grade/paths-grades",
    );
    return response;
  },
  async update(body: UpdatePathsGradesConfig): Promise<void> {
    await httpClient.patch("v1/config/internal-grade/paths-grades", body);
  },
};

export default ConfigurationsPathsGradesService;
